import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
html {
  height: 100%
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {  
  background-color: #02283c;   
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`;
